// socket.js
import { io } from "socket.io-client";
import { socketUrl } from "./baseUrl";
const socket = io(socketUrl);

export default socket;
